import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Comment from './icon-comment.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Comment {...validProps} />;
}
SvgComponent.iconName = 'comment';

/**
 * @deprecated This is a legacy icon
 */
export const CommentIcon = svgIconWrapper(SvgComponent);
